"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var sanitize_1 = require("@utils/sanitize");
var sanitizeUtils_1 = require("./sanitizeUtils");
function HtmlHighlightText(props) {
    var partToHighlight = props.partToHighlight, value = props.value;
    return (react_1.default.createElement("span", null, partToHighlight && Array.isArray(partToHighlight) && partToHighlight.length > 0
        ? partToHighlight.map(function (highlight, index) {
            var text = (0, sanitizeUtils_1.replaceLessThanSignWithHtmlEntity)(highlight.text);
            var sanitizedContent = (0, sanitize_1.evaSanitize)(text);
            return react_1.default.createElement("span", { key: index, dangerouslySetInnerHTML: { __html: sanitizedContent } });
        })
        : value));
}
exports.default = HtmlHighlightText;
